<div class="popup">
  <div class="backdrop" (click)="close.emit()"></div>
  @if (requestAreaChangeData().possibleGroupIdxList) {
    <div class="content">
      <div class="top flex flex-row gap-3">
        <h3 class="title">{{ translation.navigation.navigationInProgressMultipleRoutes | transloco }}</h3>

        <div class="top-close" (click)="close.emit()">
          <cue-icon [icon]="ICONS.cueClose" />
        </div>
      </div>
      <div class="top flex flex-col gap-3 items-center">
        <h3 class="description">
          {{ translation.navigation.navigationInProgressMultipleRoutesDescription | transloco }}
        </h3>
        <div class="flex flex-col gap-2">
          @for (item of requestAreaChangeData().possibleGroupIdxList; track item; let idx = $index) {
            <button
              (click)="continueRouteWithSpecificGroupIdx.emit(item)"
              cue-button
              size="small"
              class="change-route-mobile"
              data-cy="change-route"
            >
              <cue-icon [icon]="ICONS.cueNavigationCircle" />
              {{ translation.navigation.continueWithRouteNr | transloco }} {{ idx }}
            </button>
          }
        </div>
      </div>
    </div>
  } @else {
    @if (requestAreaChangeData().source === changeAreaSourceEnum.ItemDetail) {
      <div class="content">
        <div class="top flex flex-row gap-3">
          <h3 class="title">
            @if (requestAreaChangeData().source === changeAreaSourceEnum.ItemDetail) {
              {{ translation.navigation.navigationChangeRouteFromDetail | transloco }}
            } @else {
              {{ translation.navigation.navigationInProgress | transloco }}
            }
          </h3>

          <div class="top-close" (click)="close.emit()">
            <cue-icon [icon]="ICONS.cueClose" />
          </div>
        </div>
        <div>
          <h2 class="resource-title">{{ requestAreaChangeData().resourceName | localizedString }}</h2>
        </div>
        <div class="top flex flex-col gap-3 items-center">
          <div class="flex flex-col gap-2">
            <button
              (click)="close.emit()"
              cue-button
              size="small"
              class="link change-route-mobile"
              data-cy="change-route"
            >
              <cue-icon [icon]="ICONS.cueNavigationCircle" />
              {{ translation.navigation.continueInNavigation | transloco }}
            </button>

            @if (!isKiosk()) {
              <button
                (click)="setAsStart()"
                cue-button
                size="small"
                [class.link]="!requestAreaChangeData().startSelectionPriority"
                class="change-route-mobile"
                data-cy="change-route"
              >
                <cue-icon [icon]="ICONS.cueClose" />
                {{ translation.navigation.setAsStart | transloco }}
              </button>
            }

            <button
              (click)="setAsTarget()"
              cue-button
              size="small"
              [class.link]="requestAreaChangeData().startSelectionPriority"
              class="change-route-mobile"
              data-cy="change-route"
            >
              <cue-icon [icon]="ICONS.cueClose" />
              {{ translation.navigation.setAsTarget | transloco }}
            </button>
          </div>
        </div>
      </div>
    } @else {
      <div class="content">
        <div class="top flex flex-row gap-3">
          @if (requestAreaChangeData().source === changeAreaSourceEnum.ItemDetail) {
            <h3 class="title">{{ translation.navigation.navigationChangeRouteFromDetail | transloco }}</h3>
            <div>{{ requestAreaChangeData().resourceName | localizedString }}</div>
          } @else {
            <h3 class="title">{{ translation.navigation.navigationInProgress | transloco }}</h3>
          }

          <div class="top-close" (click)="close.emit()">
            <cue-icon [icon]="ICONS.cueClose" />
          </div>
        </div>
        <div class="top flex flex-col gap-3 items-center">
          <h3 class="description">{{ translation.navigation.navigationInProgressDescription | transloco }}</h3>
          <div class="flex flex-col gap-2">
            <button (click)="close.emit()" cue-button size="small" class="change-route-mobile" data-cy="change-route">
              <cue-icon [icon]="ICONS.cueNavigationCircle" />
              {{ translation.navigation.continueInNavigation | transloco }}
            </button>
            <button
              (click)="changeRoute.emit()"
              cue-button
              size="small"
              class="change-route-mobile"
              data-cy="change-route"
            >
              <cue-icon [icon]="ICONS.cueNavigationCircle" />
              {{ translation.navigation.changeRoute | transloco }}
            </button>

            @for (item of requestAreaChangeData().possibleGroupIdxList; track item; let idx = $index) {
              <button
                (click)="changeRoute.emit()"
                cue-button
                size="small"
                class="change-route-mobile"
                data-cy="change-route"
              >
                <cue-icon [icon]="ICONS.cueNavigationCircle" />
                {{ translation.navigation.changeRoute | transloco }} {{ idx }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
